<div id="splash">
</div>
<ion-app>
  <ion-split-pane contentId="main-content" when="lg">
    <ion-menu contentId="main-content" type="overlay" class="navMenu">
      <ion-content>
        <ion-grid>
          <ion-row class="ion-align-items-center">
            <ion-col size="12" class="ion-align-self-center">
              <ion-icon class="logo" name="c-logo" id="cLogo">
              </ion-icon>
            </ion-col>
          </ion-row>
          <ion-row class="ion-align-items-center">
            <ion-col size="12" class="ion-align-self-center" class="claimrow">
              {{ 'burgermenu.claim' | translate}}
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-list id="left-menu">
                <!--Sonderbehandlung Logout-->
                <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages; let i = index" >
                  <ion-item routerDirection="root" lines="none" detail="false" id="logOutButton"
                  routerLinkActive="selected" *ngIf="p.title==='burgermenu.logout'" (click)="logout()">
                    <ion-icon slot="start" [name]="p.icon">
                    </ion-icon>
                    <ion-label class="ion-text-wrap">
                      {{ p.title | translate}}
                    </ion-label>
                    <!--Sonderbehandlung Demovideo-->
                  </ion-item>
                  <ion-item routerDirection="root" lines="none" detail="false" id="videoButton"
                  routerLinkActive="selected" *ngIf="p.title==='burgermenu.demo'">
                    <ion-icon slot="start" [name]="p.icon">
                    </ion-icon>
                    <ion-label class="ion-text-wrap">
                      <a [href]="videoLink" class="videoLink">
                      {{ p.title | translate}}
                      </a>
                    </ion-label>
                  </ion-item>
                  <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false"
                  routerLinkActive="selected" *ngIf="p.title!=='burgermenu.logout'&&p.title!=='burgermenu.demo'" [id]="'burgermenuItem'+i">
                    <ion-icon slot="start" [name]="p.icon">
                    </ion-icon>
                    <ion-label class="ion-text-wrap">
                      {{ p.title | translate}}
                      <span class="navicount">
                      <ng-container *ngIf="p.sp_count>0">
                        ({{p.sp_count}})
                      </ng-container>
                      <ng-container *ngIf="p.capacity>0">
                        ({{p.capacity}})
                      </ng-container>
                    </span>
                    </ion-label>
                  </ion-item>
                </ion-menu-toggle>
              </ion-list>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <div class="version-number">
                v{{AppVersion}}
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content">
    </ion-router-outlet>
  </ion-split-pane>
  <app-cigarselector *ngIf="getUser()">
  </app-cigarselector>
</ion-app>
